import { Model } from './model';

export class Shipowner extends Model {
  id: number;
  name: number;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new Shipowner(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/shipowner.ts